











import { Component, Vue } from 'vue-property-decorator'
@Component({})
export default class MdcListItemText extends Vue{
  get hasPrimary(){
    return this.$slots['primary'] !== undefined
  }
  get hasSecondary(){
    return this.$slots['secondary'] !== undefined
  }
}
